import { ElementsSDK, UiUtilities } from '@yiluhub/ui-sdk-react';
import { SearchItem } from '@yiluhub/yilu-amp-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  getEurailProductDetails,
  getTravelDaysLabel,
  getTravelDurationLabel,
} from 'modules/eurail/utils/getProductDetails';

import './styles.scss';

export type EurailSrpResultCardProps = {
  data: SearchItem;
  onClick?: (data: SearchItem) => unknown;
};

const EuRailSrpResultCard: React.FC<EurailSrpResultCardProps> = ({ data, onClick }) => {
  const { t } = useTranslation();
  const { isVisible, onShow, onHide } = ElementsSDK.useModal(false);
  const {
    numberOfTravelDays,
    numberOfPassengers,
    validityPeriodMonth,
    price,
    currency,
    productName,
  } = getEurailProductDetails(data);

  const travelDays = getTravelDaysLabel(t, numberOfTravelDays);
  const travelDuration = getTravelDurationLabel(t, validityPeriodMonth);

  return (
    <div className="eurail-Search-Results__Result-Card">
      <div className="eurail-SearchResults__ResultCard-UpperBox">
        <div className="eurail-Search-Results__Result-Card-Icon-Container">
          <div className="eurail-Search-Results__Result-Card-Icon">
            <ElementsSDK.Icon.CustomLuggage />
          </div>
        </div>
        <div className="eurail-Search-Results__Result-Card-Header">
          <ElementsSDK.Typography
            variant="p1"
            bold
            className="eurail-Search-Results__Result-Card-Days"
          >
            {travelDays}
            <span className="eurail-Search-Results__Result-Card-Period">{travelDuration}</span>
          </ElementsSDK.Typography>
          <ElementsSDK.Link className="eurail-Search-Results__Result-Card-Details" onClick={onShow}>
            {t('eurail.searchresults.view-details.text')}
          </ElementsSDK.Link>
          <ElementsSDK.Modal
            size={ElementsSDK.ModalSize.LARGE}
            isVisible={isVisible}
            onConfirm={onHide}
            isResponsiveModeEnabled
            onClickOutside={onHide}
            confirmText={t('Close')}
          >
            <ElementsSDK.Typography variant="h3" bold>
              {productName}
            </ElementsSDK.Typography>
            <ElementsSDK.Divider></ElementsSDK.Divider>
            <ElementsSDK.Typography variant="h4">
              {t('eurail.viewdetails.gotoknow.text')}
            </ElementsSDK.Typography>

            <ElementsSDK.Typography
              variant="p1"
              dangerouslySetInnerHTML={{ __html: t('eurail.viewdetails.modal.text') }}
            ></ElementsSDK.Typography>
          </ElementsSDK.Modal>
        </div>
      </div>
      <ElementsSDK.Divider />
      <div className="eurail-Search-Results__Result-Card-Footer">
        <div className="eurail-Search-Results__Result-Card-Persons">
          <ElementsSDK.Icon.PersonOutline></ElementsSDK.Icon.PersonOutline>
          {numberOfPassengers}
        </div>
        <button
          className="eurail-Search-Results__Result-Card-Price"
          onClick={() => onClick?.(data)}
        >
          <ElementsSDK.Typography variant="h3" bold>
            {price ? UiUtilities.formatCurrency(price, currency) : undefined}
            <ElementsSDK.Icon.ArrowRightChevron className="eurail-Search-Results__Result-Card-Arrow-Icon" />
          </ElementsSDK.Typography>
        </button>
      </div>
    </div>
  );
};

export default EuRailSrpResultCard;
